import {
  LIVE_STREAMING,
  LIVE_STREAMING_SUCCESS,
  LIVE_STREAMING_FAILURE,
  DELETE_EVENT,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAILURE,
  END_EVENT,
  END_EVENT_SUCCESS,
  END_EVENT_FAILURE,
  SEND_EVENT_NOTIFICATION,
  SEND_EVENT_NOTIFICATION_SUCCESS,
  SEND_EVENT_NOTIFICATION_FAILURE,
  SEND_EVENT_EMAIL,
  SEND_EVENT_EMAIL_SUCCESS,
  SEND_EVENT_EMAIL_FAILURE,
} from "../constants";

export default class AdsAction {
  static getLiveStreaming(payload, cb) {
    return {
      type: LIVE_STREAMING,
      payload,
      cb,
    };
  }
  static getLiveStreamingSuccess(payload) {
    return {
      type: LIVE_STREAMING_SUCCESS,
      payload,
    };
  }
  static getLiveStreamingFailure() {
    return {
      type: LIVE_STREAMING_FAILURE,
    };
  }
  static deleteEvent(id, cb) {
    return {
      type: DELETE_EVENT,
      payload: { id },
      cb,
    };
  }

  static deleteEventSuccess(payload) {
    return {
      type: DELETE_EVENT_SUCCESS,
      payload,
    };
  }

  static deleteEventFailure(payload) {
    return {
      type: DELETE_EVENT_FAILURE,
      payload,
    };
  }
  static endEvent(id, cb) {
    return {
      type: END_EVENT,
      payload: { id, cb },
    };
  }

  static endEventSuccess(payload) {
    return {
      type: END_EVENT_SUCCESS,
      payload,
    };
  }

  static endEventFailure(payload) {
    return {
      type: END_EVENT_FAILURE,
      payload,
    };
  }
  static sendEventNotification(payload, cb) {
    return {
      type: SEND_EVENT_NOTIFICATION,
      payload,
      cb,
    };
  }

  static sendEventNotificationSuccess(payload) {
    return {
      type: SEND_EVENT_NOTIFICATION_SUCCESS,
      payload,
    };
  }

  static sendEventNotificationFailure(payload) {
    return {
      type: SEND_EVENT_NOTIFICATION_FAILURE,
      payload,
    };
  }
  static sendEventEmail(payload, cb) {
    return {
      type: SEND_EVENT_EMAIL,
      payload,
      cb,
    };
  }

  static sendEventEmailSuccess(payload) {
    return {
      type: SEND_EVENT_EMAIL_SUCCESS,
      payload,
    };
  }

  static sendEventEmailFailure(payload) {
    return {
      type: SEND_EVENT_EMAIL_FAILURE,
      payload,
    };
  }
}
